import {AuthService} from '@shared/services/security/auth.service';
import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, RouterOutlet, RoutesRecognized,} from '@angular/router';
import {HeaderComponent} from '@components/header/header.component';
import {FooterComponent} from '@components/footer/footer.component';
import {SidebarComponent} from '@components/sidebar/sidebar.component';
import {CommonModule} from '@angular/common';
import {CalendarOptions} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import {FullCalendarModule} from '@fullcalendar/angular';
import {DEFAULT_INTERRUPTSOURCES, Idle} from "@ng-idle/core";
import {ModalDismissReasons, NgbModal, NgbModalModule, NgbProgressbarModule} from '@ng-bootstrap/ng-bootstrap';
import {filter, map} from "rxjs";
import {PageStylesEnum} from "@shared/services/router/page-styles.enum";
import {CdssHeaderComponent} from "@cdss/components/header/cdss-header.component";
import {CdssSidebarComponent} from "@cdss/components/sidebar/cdss-sidebar.component";
import {PageTypesEnum} from "@shared/services/router/page-types.enum";

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        HeaderComponent,
        FooterComponent,
        SidebarComponent,
        CommonModule,
        FullCalendarModule,
        NgbProgressbarModule,
        NgbModalModule,
        CdssHeaderComponent,
        CdssSidebarComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    @ViewChild(HeaderComponent) headerComponent: HeaderComponent
    @ViewChild(CdssHeaderComponent) cdssHeaderComponent: CdssHeaderComponent

    title = 'univa-health';

    idleState = "NOT_STARTED";
    countdown?: number = null;
    percentage?: number = null;
    idleTimeout: number = 30

    calendarOptions: CalendarOptions = {
        initialView: 'dayGridMonth',
        plugins: [dayGridPlugin],
        events: [
            {title: 'Event 1', date: '2024-05-20'},
            {title: 'Event 2', date: '2024-05-21'},
        ],
    };

    layoudDisabledRoutes = ['/signin', '/forgot-password', '/reset-password', '/sign-remote-icf', '/select-type'];

    type: string
    style: string

    constructor(
        private router: Router,
        private authService: AuthService,
        private idle: Idle,
        private cd: ChangeDetectorRef,
        private modalService: NgbModal,
        private route: ActivatedRoute,
    ) {
        idle.setIdle(600); // how long can they be inactive before considered idle, in seconds
        idle.setTimeout(this.idleTimeout); // how long can they be idle before considered timed out, in seconds
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        idle.onIdleStart.subscribe(() => {
            this.idleState = "IDLE";
        });
        // do something when the user is no longer idle
        idle.onIdleEnd.subscribe(() => {
            this.idleState = "NOT_IDLE";
            this.countdown = null;
            cd.detectChanges();
        });
        // do something when the user has timed out
        idle.onTimeout.subscribe(() => {
            this.resetIdle()
            this.modalService.dismissAll(ModalDismissReasons.ESC)
            if (this.headerComponent != undefined) {
                this.headerComponent.logOut()
            }
            if (this.cdssHeaderComponent != undefined) {
                this.cdssHeaderComponent.logOut()
            }
        });
        // do something as the timeout countdown does its thing
        idle?.onTimeoutWarning?.subscribe((seconds: number) => {
            this.countdown = seconds
            this.percentage = 100 - seconds * 100 / this.idleTimeout
        });
    }

    ngOnInit(): void {
        this.resetIdle()
        this.router.events.pipe(
            filter(event => event instanceof RoutesRecognized),
            map((event: RoutesRecognized) => {
                return event.state.root.firstChild.data;
            })
        ).subscribe(routeData => {
            this.type = routeData['type'] ?? this.authService.getCurrentType()
            this.style = routeData['style'] ?? PageStylesEnum.BASIC
        })
    }


    resetIdle() {
        this.idle.watch();
        this.idleState = "NOT_IDLE";
        this.countdown = null;
    }

    get isUserLogged(): boolean {
        return this.authService.isUserLogged;
    }

    get isLayoutDisabled(): boolean {
        return !this.authService.isUserLogged ||
            this.layoudDisabledRoutes.some((route: string) => this.router.url.includes(route));
    }

    protected readonly PageTypesEnum = PageTypesEnum;
}
